export default __webpack_public_path__ + "static/media/4T0A9729.77e751d1.jpg";